import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Input } from '@iq/react-components';
import Heading from '../../../../Heading/Heading';
import NotificationFilter from '../NotificationFilter';
import RoleList from './RoleList';
import { getRoleNotificationConfigs } from '../../../../../bundles/notification-config';
import { getMembers } from '../../../../../bundles/auth';
import { getActiveSite } from '../../../../../bundles/sites';
import { DELIVERY_FILTER_OPTIONS } from '../../constants';

const RolesTab = () => {
  const [searchText, setSearchText] = useState('');
  const [activeFilters, setActiveFilters] = useState({ role: [], delivery: [] });
  const roleConfigs = useSelector(getRoleNotificationConfigs);
  const site = useSelector(getActiveSite);
  const siteMembers = useSelector((state) => getMembers(state, `site/${site?.id}`));

  const roles = useMemo(() => {
    if (!siteMembers || siteMembers.length === 0) return [];
    return siteMembers.map((member) => {
      const config = roleConfigs.find((c) => c.role === member.id);
      return { ...member, config };
    });
  }, [siteMembers, roleConfigs]);

  const roleOptions = useMemo(() => {
    return siteMembers.map((m) => ({ value: m.id, label: m.type }));
  }, [siteMembers]);

  const filteredRoles = useMemo(() => {
    let result = roles;
    if (searchText) {
      const search = searchText.toLowerCase();
      result = result.filter((r) => r.type?.toLowerCase().includes(search));
    }
    if (activeFilters.role.length > 0) {
      const roleIds = new Set(activeFilters.role.map((r) => r.value));
      result = result.filter((r) => roleIds.has(r.id));
    }
    if (activeFilters.delivery.length > 0) {
      const deliveryKeys = new Set(activeFilters.delivery.map((d) => d.value));
      result = result.filter((r) => {
        if (!r.config) return false;
        const settings = r.config.stateChangeSettings || {};
        return Object.values(settings).some((s) =>
          [...deliveryKeys].some((key) => s[key] === true)
        );
      });
    }
    return result;
  }, [roles, searchText, activeFilters]);

  const filters = useMemo(
    () => [
      { key: 'role', label: 'Role', options: roleOptions },
      { key: 'delivery', label: 'Delivery Options', options: DELIVERY_FILTER_OPTIONS },
    ],
    [roleOptions]
  );

  return (
    <div className="roles-tab">
      <Heading
        contentLeft={
          <>
            <Input
              placeholder="Search..."
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
            />
            <NotificationFilter
              filters={filters}
              onApply={setActiveFilters}
              onReset={() => setActiveFilters({ role: [], delivery: [] })}
            />
          </>
        }
      />
      <RoleList roles={filteredRoles} />
    </div>
  );
};

export default RolesTab;
